import { render, staticRenderFns } from "./TaxPph22Import.vue?vue&type=template&id=6f9ef632"
import script from "./TaxPph22Import.vue?vue&type=script&lang=js"
export * from "./TaxPph22Import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports